// ProjectContext.js
import React, { createContext, useContext, useState } from 'react';

const ProjectContext = createContext();

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};

export const ProjectProvider = ({ children }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectId, setProjectId] = useState(null);

  const selectProject = (project) => {
    setSelectedProject(project);
    setProjectId(project.id || project.project_id);
    // Store in localStorage for persistence across page refreshes
    localStorage.setItem('selectedProjectId', project.id || project.project_id);
    localStorage.setItem('selectedProject', JSON.stringify(project));
  };

  const clearProject = () => {
    setSelectedProject(null);
    setProjectId(null);
    localStorage.removeItem('selectedProjectId');
    localStorage.removeItem('selectedProject');
  };

  // Initialize from localStorage on mount
  React.useEffect(() => {
    const storedProjectId = localStorage.getItem('selectedProjectId');
    const storedProject = localStorage.getItem('selectedProject');
    
    if (storedProjectId && storedProject) {
      setProjectId(storedProjectId);
      setSelectedProject(JSON.parse(storedProject));
    }
  }, []);

  return (
    <ProjectContext.Provider
      value={{
        selectedProject,
        projectId,
        selectProject,
        clearProject
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};